import React from 'react';
import useZoomedMap from '../../hooks/useZoomedMap';

// passing lifted state and its change handler in as function args
export default function ZoomedMap({
  stateSchema,
  locationIDs,
  handleLocationIDsChange,
  riverID,
  handleRiverIDChange,
  operationalStates
}) {
  const { zoomedMap, handleMapStyleChange, toggleableLayers } = useZoomedMap({
    stateSchema,
    locationIDs,
    handleLocationIDsChange,
    riverID,
    handleRiverIDChange,
    operationalStates
  });

  // console.log(toggleableLayers);

  return (
    <>
      <div>
        <span className='layer-button-Legend'>Basemap: </span>
        {['light-v10', 'dark-v10', 'streets-v11', 'satellite-v9'].map(
          (item) => {
            return (
              <button
                className='basemap-layer-button'
                key={item}
                id={item}
                onClick={() => handleMapStyleChange(item)}
              >
                {item.split('-')[0]}
              </button>
            );
          }
        )}
        {toggleableLayers && (
          <div>
            <span className='layer-button-Legend'>Layers: </span>
            {toggleableLayers}
          </div>
        )}
      </div>
      <div className='zoom-map-container' id='menu' ref={zoomedMap}></div>
    </>
  );
}
